import api from "app/lib/api";
import cacheApi from "app/lib/cacheApi";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

/**
 * Get selectors data for report note templates
 * @returns {Promise}
 */
export const getReportNoteTemplateSelectors = async () => {
  const { data } = await api.get(endpoints.reportTemplates.selectors);

  return data;
};

/**
 * Get reports note templates
 *
 * @returns {Promise}
 */
export const getReportNoteTemplates = async () => {
  const { data } = await api.get(endpoints.reportTemplates.getAll);

  return data;
};

/**
 * Upsert report note template
 * @param {Object} payload
 * @param {boolean} isEdit
 * @returns {Promise}
 */
export const upsertReportNoteTemplate = async (payload, isEdit = false) => {
  let response;
  if (isEdit) {
    const { id, ...rest } = payload;
    const url = interpolate(endpoints.reportTemplates.getById, { id });

    response = await api.put(url, rest);
  } else {
    response = await api.post(endpoints.reportTemplates.getAll, payload);
  }

  return response?.data;
};

/**
 * Delete report note template
 * @param {string} id
 * @returns {Promise}
 */
export const deleteReportNoteTemplate = async (id) => {
  const url = interpolate(endpoints.reportTemplates.getById, { id });

  await api.delete(url);
};

/**
 * Fetch report template for the given payload
 * @param {*} payload
 * @returns
 */
export const fetchReportTemplate = async (payload) => {
  const url = endpoints.reportTemplates.getByReportInformation;

  if (payload) {
    const { data } = await cacheApi.post(url, payload);

    return data;
  }
};
